import { Box, Stack, Typography } from '@mui/material';
import section4_icon1 from 'assets/img/ECommerce/section4_icon1.png';
import section4_icon2 from 'assets/img/ECommerce/section4_icon2.png';
import section4_icon3 from 'assets/img/ECommerce/section4_icon3.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import theme from 'theme/index';
import { E_COMMERCE_STYLES } from './config';
import { Link } from 'react-router-dom';
import { paths } from 'routes/routes/paths';

type Feature = { title: string; body: string; icon?: string };

export default function Section4(): JSX.Element {
  const items: Feature[] = [
    {
      title: 'GCC Buying Behavior',
      body: 'UX tuned to local preferences — mobile-first, Arabic RTL, and trust-driven.',
      icon: section4_icon1,
    },
    {
      title: 'Business Systems Integration',
      body: 'Fully connected with existing ERP, CRM, and internal flows.',
      icon: section4_icon2,
    },
    {
      title: 'Sustainable Long-Term Goals',
      body: 'Built to be future-ready and aligned with enterprise long-term goals — without the need for replatforming.',
      icon: section4_icon3,
    },
  ];

  return (
    <Box sx={{ px: 2, py: 4, pt: 3, bgcolor: '#fff' }}>
      <Stack
        spacing={2}
        maxWidth={E_COMMERCE_STYLES.container.maxWidth}
        mx={E_COMMERCE_STYLES.container.mx}
      >
        <Typography variant="h2" fontWeight={800} className="font-helvetica-bold">
          Why Most GCC E‑Commerce Brands <span style={{ color: '#ef4444' }}>Don’t Sustain?</span>
        </Typography>
        <Typography
          variant="body1"
          fontSize={22}
          color="text.black"
          className="font-helvetica-light"
          sx={{ fontWeight: '100' }}
        >
          Over 85% of GCC online stores rely on plug-and-play platforms. But only the top 1% invest
          in systems built to scale and last.
        </Typography>
        <Typography
          variant="h1"
          mb={3}
          fontSize={80}
          color={theme.palette.darkBlue.main}
          className="font-helvetica-thin"
          sx={{ fontWeight: '100', lineHeight: '45px' }}
        >
          1%
        </Typography>
        <Typography
          variant="body2"
          color="text.black"
          className="font-helvetica-light"
          sx={{ fontWeight: '100', width: '90%' }}
        >
          <b> Osperb builds for that 1% </b>— custom-engineered e-commerce aligned with GCC buying
          behavior, <br /> business system integration, and sustainable long-term goals.
        </Typography>

        <Stack
          pb={1}
          pt={1}
          spacing={2}
          mt={3}
          sx={{
            background: 'linear-gradient(to bottom, #FFFBEC, #FFFBE8)',
          }}
        >
          {items?.map((item, key) => (
            <Box
              key={key}
              sx={{
                p: 3,
                pb: 1,
                pl: 1,
                pt: 2,
                borderRadius: 2,
                gap: 1.5,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'start',
              }}
            >
              <Box
                component="img"
                src={item?.icon}
                alt="hero"
                sx={{
                  width: '22px',
                  height: '22px',
                  mt: 0.5,
                }}
              />
              <Box>
                <Typography className="font-helvetica-bold" variant="h5">
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={100}
                  className="font-helvetica-light"
                  color="#000"
                >
                  {item.body}
                </Typography>
              </Box>
            </Box>
          ))}
        </Stack>

        <Link to={paths.public.schedule}>
          <AnimatedButton
            label="Build A Sustainable E‑commerce"
            sx={{
              textAlign: 'start',
            }}
          />
        </Link>
        <Typography maxWidth={320} mt={1} variant="body2" color="#676767" className="font-serif">
          Just a{' '}
          <b>
            <u> 60-minute deep dive</u>{' '}
          </b>{' '}
          into save you months of frustration and rework.
        </Typography>
      </Stack>
    </Box>
  );
}
